//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ['tags', 'nomore', 'membertag'],
  computed: {
    /**
     * @description 根据路由获取当前 id
     * @returns { String } 当前路由 id
     */
    pageVal() {
      return this.$route.params.type;
    },
    /**
     * @description 判断是否是会员栏目
     * @returns { Object } 会员栏目信息
     */
    isMemberTag() {
      const arr = this.membertag.filter(item => item.equityId === this.pageVal);
      return arr.length > 0 ? arr[0] : null;
    },
    /**
     * @description 当前选中栏目
     * @returns { String } 当前栏目值
     */
    currentTag() {
      if (this.isMemberTag) {
        return 'member';
      }
      return this.pageVal;
    },
    /**
     * @description 会员栏目选中文案
     * @returns { String } 当前栏目文案
     */
    memberSelect() {
      return (this.isMemberTag && this.isMemberTag.title) || '精选栏目';
    },
  },
  methods: {
    preventDefault(e) {
      // 阻止默认事件
      const event = e || window.event;
      event.preventDefault();
    },
    toMemberArticleList(type) {
      this.$router.push({
        path: `/tag/${type}`,
      });
    },
  },
};
